import React from "react"
import { Authority, useAuthenticated } from "providers/A12n"

type Props = {
  allowed?: Authority[]
  fallback?: JSX.Element
  children: JSX.Element
}
/*
  TODO: properly use the forwarded ref for children that need it
  for now the forwardRef function just hides the warning message
*/
export const WithAuthority = React.forwardRef(
  ({ allowed, fallback, children }: Props, _ref) => {
    const { hasAuthority } = useAuthenticated()

    if (!allowed) {
      return children
    }

    return hasAuthority(allowed) ? children : fallback || null
  },
)
